import { withNamespaces } from 'react-i18next';
import { Alert } from 'reactstrap';

const StatusCheck = ({
    ok,
    label,
}) => (
    <span className={`d-inline-flex align-items-center font-size-12 me-4${ok ? '' : ' text-muted'}`}>
        <i className={`${ok ? 'ri-check-line' : 'ri-subtract-line'} me-1`} />
        {label}
    </span>
);

const StatusSummary = ({
    t,
    active,
    providerLabel,
    emailAddress,
    imapSyncEnabled,
    isMicrosoft,
    oauthConnected,
}) => {
    if (!active) {
        return (
            <Alert color="light" className="border d-flex align-items-start mb-4">
                <i className="ri-close-circle-line font-size-22 me-2 text-muted" />
                <div>
                    <div className="fw-semibold">
                        {t('Email settings inactive')}
                    </div>
                    <div className="text-muted font-size-12">
                        {t('The system is not sending emails. Save the settings and activate them to start sending.')}
                    </div>
                </div>
            </Alert>
        );
    }

    const details = [providerLabel, emailAddress].filter(Boolean).join(' · ');

    return (
        <Alert color="success" className="d-flex align-items-start mb-4">
            <i className="ri-checkbox-circle-line font-size-22 me-2" />
            <div>
                <div className="fw-semibold">
                    {t('Email settings active')}
                </div>
                {details && (
                    <div className="font-size-12 mb-1">
                        {details}
                    </div>
                )}
                <div className="d-flex flex-wrap">
                    <StatusCheck
                        ok
                        label={t('Sending enabled')}
                    />
                    <StatusCheck
                        ok={imapSyncEnabled}
                        label={imapSyncEnabled
                            ? t('Inbox sync enabled')
                            : t('Inbox sync disabled')}
                    />
                    {isMicrosoft && (
                        <StatusCheck
                            ok={oauthConnected}
                            label={oauthConnected
                                ? t('Microsoft connected')
                                : t('Microsoft not connected')}
                        />
                    )}
                </div>
            </div>
        </Alert>
    );
};

export default withNamespaces()(StatusSummary);
